// import { Injectable } from '@angular/core';

import { Injectable } from "@angular/core";
import { 
  ActivatedRouteSnapshot, 
  Resolve, 
  Router, 
  RouterStateSnapshot 
} from "@angular/router";
import { ClientsService } from "app/services/client/ClientsService";
import { ToastrService } from "ngx-toastr";
import { Observable } from "rxjs";

@Injectable()
export class CheckResetPasswordCodeResolverService implements Resolve<{userEmail: string, validCode: boolean}>{

  constructor(
    private clientService: ClientsService, 
    private router: Router,
    private toast: ToastrService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<{userEmail: string, validCode: boolean}>{
    return  new Observable<{userEmail: string, validCode: boolean}>((observer) => {
      console.log('id', route.params['id']);
      console.log('code', route.params['code']);

      const userId = parseInt(route.params['id']);
      const code = route.params['code'];

      this.clientService.getUserInfo(userId).subscribe((data: any) => {
        console.log("response_GetUserInfo", data);

        if (data && data.result) {
            const email = String(data.result.Email);

            this.clientService.resetPasswordCodeIsValid(userId, code).subscribe((response: any) => {
              if (Number(response.result.Result) === 1) {
                const isValid = JSON.parse(response.result.Data);
                observer.next({userEmail: email, validCode: isValid});
              } else {
                this.toast.error('Invalid reset password link.', 'ELI');
                this.router.navigate(['/login']);
                observer.next({userEmail: email, validCode: false});
              }
              
              observer.complete();
            }, 
            (error) => {
              observer.next({userEmail: email, validCode: false});
              this.router.navigate(['/login']);
              this.toast.error('We are sorry. Unexpected error checking reset password link.', 'ELI');
              observer.complete();
            });
        } else {
          this.toast.error('Invalid reset password link.', 'ELI');
          this.router.navigate(['/login']);

          observer.next({userEmail: '', validCode: false});
          observer.complete();
        }
    },
    (error) => {
      observer.next({userEmail: '', validCode: false});
              this.router.navigate(['/login']);
              this.toast.error('We are sorry. Unexpected error getting user information.', 'ELI');
              observer.complete();
    });
    });
  }

}
